import { AnimatedSpinnerGapIcon } from '@monorepo/shared/componentsV2/animation/AnimatedSpinnerGapIcon';
import {
  InfoCard,
  InfoCardVariant,
} from '@monorepo/shared/componentsV2/InfoCard';
import { useToast } from '@monorepo/shared/contexts';
import { usePrevious } from '@monorepo/shared/hooks/usePrevious';
import React, { useEffect } from 'react';
import styled from 'styled-components';

const StyledInfoCard = styled(InfoCard)`
  overflow: visible;
`;

export function QueryOriginStatusAlert({
  originStatus,
  areQueryResultsLoading,
}: {
  originStatus?: { isStale: boolean };
  areQueryResultsLoading: boolean;
}) {
  const wasStale = usePrevious(originStatus?.isStale);
  const isReloadingAfterBeingStale =
    wasStale && areQueryResultsLoading && !originStatus?.isStale;
  const wasReloadingAfterBeingStale = usePrevious(isReloadingAfterBeingStale);

  const { success } = useToast();

  useEffect(() => {
    if (wasReloadingAfterBeingStale && !isReloadingAfterBeingStale) {
      success('Recalculation complete.');
    }
  }, [isReloadingAfterBeingStale, success, wasReloadingAfterBeingStale]);

  if (originStatus?.isStale || isReloadingAfterBeingStale) {
    return (
      <StyledInfoCard
        icon={<AnimatedSpinnerGapIcon />}
        variant={InfoCardVariant.WARNING}
      >
        Recalculation in progress. The data source for this table has been
        recently updated and data may not be accurate.
      </StyledInfoCard>
    );
  }

  return null;
}
